export default "__VITE_ASSET__D3h5Sm____"